// @flow

import * as React from 'react';
import type { Node } from 'react';
import Select from 'react-select';
import './style.scss';

/**
 * @function SelectInput
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.placeholder
 * @param {string} props.value
 * @param {Array<OptionType>} props.options
 * @param {string | Node} props.label
 * @param {void} props.onChange
 * @returns {Node}
 * @exports SelectInput
 */

type OptionType = { [string]: any };

type SelectState = {
  isFocused: boolean,
  isSelected: boolean,
};

type Props = {
  label: string,
  id: string,
  placeholder: string,
  options: Array<OptionType>,
  onChange: () => void,
  value: string,
};

// * https://react-select.com/styles
const customStyles = {
  control: (provided: OptionType, state: SelectState) => ({
    ...provided,
    border: 'none',
    boxShadow: state.isFocused && '0 0 0 1px #4ecca3',
    background: '#393e46',
    color: '#ffffff',
    padding: '0 10px',
    cursor: 'pointer',
  }),
  menu: (provided: OptionType) => ({
    ...provided,
    background: '#393e46',
    boxShadow: '2px 10px 30px 10px rgba(0,0,0,.3)',
  }),
  input: (provided: OptionType) => ({
    ...provided,
    color: '#fff',
  }),
  option: (provided: OptionType, state: SelectState) => ({
    ...provided,
    color: state.isSelected ? '#4ecca3' : '#fff',
    background: state.isFocused ? '#232931' : '#393e46',
    margin: 0,
    padding: 15,
    cursor: 'pointer',
  }),
  singleValue: (provided: OptionType) => ({
    ...provided,
    color: '#fff',
  }),
};
const SelectInput = (props: Props): Node => {
  const { label, id, placeholder, options, onChange, value } = props;
  return (
    <div className="Input">
      <label className="Input__label" htmlFor={id}>
        {label}
      </label>
      <Select
        placeholder={placeholder}
        id={id}
        styles={customStyles}
        setValue={() => value}
        options={options}
        onChange={onChange}
      />
    </div>
  );
};

export default SelectInput;
